import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {License} from "../../../shared/interface/license";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {Profile} from "../../../shared/interface/profile";
import {AuthService} from "../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {LicenseService} from "../../../shared/services/license.service";
import {takeUntil} from "rxjs/operators";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";

@Component({
  selector: 'app-license-details-view',
  templateUrl: './license-details-view.component.html',
  styleUrls: ['./license-details-view.component.scss']
})
export class LicenseDetailsViewComponent implements OnInit, OnDestroy {

  @Input() license: Observable<License>;
  @Output() modifyClicked = new EventEmitter<void>();

  licenseObject: License;
  userPermissions: ReplaySubject<UserPermissions>;
  profile: Profile;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private licenseService: LicenseService,
    private snack: MatSnackBar,
    private router: Router
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });
    this.license
      .pipe(takeUntil(this.destroyed$))
      .subscribe((license: License) => {
        this.licenseObject = license;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć licencję?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.licenseService.delete(this.licenseObject.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto licencję', '', {duration: 2000});
            this.router.navigate(['/licencje']);
          });
      }
    });
  }

}
